import moment from 'moment'

export function mapFilter (value, map, defaultTxt = '--') {
  if (typeof value === 'undefined') {
    return defaultTxt
  }

  return map[value] || value
}

export function dateFilter (value, format, defaultTxt = '--') {
  if (typeof value === 'undefined') {
    return defaultTxt
  }
  return moment(value).format(format)
}
